export const CLEAR_STATE = 'CLEAR_STATE';

export function clearStateAction() {
    return {
      type: CLEAR_STATE
    }
  }